// src/auth/active-project.ts
import { useQuery } from "@tanstack/react-query";
import { useSyncExternalStore } from "react";

import type { components } from "@/api/schema";

import { accessQuery } from "./queries";

type RoleType = components["schemas"]["UserRoleType"];
const KEY = "adman.activeProject";
const listeners = new Set<() => void>();

const read = () => localStorage.getItem(KEY);
const subscribe = (l: () => void) => (listeners.add(l), () => void listeners.delete(l));

export function setActiveProjectId(id: string) {
  localStorage.setItem(KEY, id);
  listeners.forEach((l) => l());
}

/** المشروع النشط الذي تُبنى عليه شاشات (الوحدات/العقود/الصيانة…) وأدوار المستخدم عليه. */
export function useAccess() {
  const query = useQuery(accessQuery);
  const stored = useSyncExternalStore(subscribe, read);
  const projects = query.data?.projects ?? [];
  const active = projects.find((p) => p.project_id === stored) ?? projects[0];
  const roles: RoleType[] = active?.roles ?? [];
  const isAdmin = query.data?.is_admin ?? false;
  const isPlatformAdmin = query.data?.is_platform_admin ?? false;
  return {
    isLoading: query.isLoading,
    isAdmin,
    isPlatformAdmin,
    projects,
    active,
    projectId: active?.project_id,
    roles,
    hasRole: (...wanted: RoleType[]) => isAdmin || wanted.some((r) => roles.includes(r)),
    setActive: setActiveProjectId,
  };
}
